// extracted by mini-css-extract-plugin
export default {"container":"WelcomePage_container__q9-wm","gradient":"WelcomePage_gradient__nT9Fu"};